import * as actionTypes from './actionTypes';

export const setError = ( err ) => ({
   type: actionTypes.UI_SET_ERROR,
   payload: err
});

export const removeError = ( err ) => ({
    type: actionTypes.UI_REM_ERROR,
});

export const startLoading = () => ({
    type: actionTypes.UI_START_LOADING
});

export const finishLoading = () => ({
    type: actionTypes.UI_FINISH_LOADING
});

export const showBookingBar = () => ({
    type: actionTypes.UI_SHOW_BOOKING_BAR
});

export const hideBookingBar = () => ({
    type: actionTypes.UI_HIDE_BOOKING_BAR
});

export const showNavBar = () => ({
    type: actionTypes.UI_SHOW_NAV_BAR
});

export const hideNavBar = () => ({
    type: actionTypes.UI_HIDE_NAV_BAR
});

export const showSaveOnModal = () => ({
   type: actionTypes.UI_SHOW_SAVE_ON_MODAL
});

export const hideSaveOnModal = () => ({
    type: actionTypes.UI_HIDE_SAVE_ON_MODAL
});